export default {
    computed: {
        countTimeModifyDiagnosisBtn(){
            if(this.$store.state.controller.editDuration){
                return this.$store.state.controller.editDuration
            }else{

                return 604800000
            }
        }
    }
}